export default "__VITE_ASSET__DyqSspnm__"